import React, { useEffect } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Grid,
  Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Import your avatar images from the assets
import RepublicDayImg from './assets/republic_day.png';
import HoliImg from './assets/holi.png';
import IndependenceDayImg from './assets/independence_day.png';
import RakshaBandhanImg from './assets/raksha_bandhan.png';
import DusserahImg from './assets/dusserah.png';
import DiwaliImg from './assets/diwali.png';
import NewYearImg from './assets/new_year.png';
import ChristmasImg from './assets/christmas.png';
import JanmashtmiImg from './assets/janmashtmi.png';
import GudiPadwaImg from './assets/gudi_padwa.png';
import GaneshChaturthiImg from './assets/ganesh_chaturthi.png';
import holidaysgif from '../../assets/holidays.gif';
import { useGetHolidaysQuery } from './holidayApiSlice';
import { useDispatch, useSelector } from 'react-redux';
// Common holidays for all cities except Pune and Rajkot
// const commonHolidays = [
//   { name: 'Republic Day', date: '26 January 2024', day: 'Friday', image: RepublicDayImg },
//   { name: 'Holi/Dhuleti', date: '25 March 2024', day: 'Monday', image: HoliImg },
//   { name: 'Independence Day', date: '15 August 2024', day: 'Thursday', image: IndependenceDayImg },
//   { name: 'Raksha Bandhan', date: '19 August 2024', day: 'Monday', image: RakshaBandhanImg },
//   { name: 'Dusserah', date: '13 October 2024', day: 'Sunday', image: DusserahImg },
//   { name: 'Diwali', date: '31 October 2024', day: 'Thursday', image: DiwaliImg },
//   { name: 'Vikram Samvat New Year', date: '1 November 2024', day: 'Friday', image: NewYearImg },
//   { name: 'Christmas', date: '25 December 2024', day: 'Wednesday', image: ChristmasImg },
// ];

// Custom holidays for Rajkot and Pune
// const holidays = {
//   Rajkot: [
//     ...commonHolidays.slice(0, 5),
//     { name: 'Janmashtmi', date: '22 August 2024', day: 'Thursday', image: JanmashtmiImg },
//     ...commonHolidays.slice(5),
//   ],
//   Pune: [
//     { name: 'Republic Day', date: '26 January 2024', day: 'Friday', image: RepublicDayImg },
//     { name: 'Holi/Dhuleti', date: '25 March 2024', day: 'Monday', image: HoliImg },
//     { name: 'Gudi Padwa', date: '9 April 2024', day: 'Tuesday', image: GudiPadwaImg },
//     { name: 'Independence Day', date: '15 August 2024', day: 'Thursday', image: IndependenceDayImg },
//     { name: 'Ganesh Chaturthi', date: '7 September 2024', day: 'Saturday', image: GaneshChaturthiImg },
//     { name: 'Diwali', date: '31 October 2024', day: 'Thursday', image: DiwaliImg },
//     ...commonHolidays.slice(6),
//   ],
// };

// List of all cities
// const cities = [
//   'Ahmedabad',
//   'Pune',
//   'Rajkot',
// ];

const Holidays = () => {
  const {data:holidays,isLoading,isError} = useGetHolidaysQuery();
  let cities = [];
  if(holidays){
     cities = Object.keys(holidays);
  }
  return (
    <Grid
      sx={{
        maxHeight: '83vh', // Adjust this value to control the max height of the scrollable area
        overflowY: 'auto',
        // border: 2,
        padding: 1,
        backgroundImage: `url(${holidaysgif})`, // Use the imported GIF
        backgroundSize: '300px 300px', // Set desired size of the GIF
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.85)', // Adjust the color and opacity here
          zIndex: 1, // Ensure the layer is above the background but below the content
        },
        '& > *': {
          position: 'relative', // Ensure that content is above the overlay
          zIndex: 2,
        },
      }}
    >
      {cities.length > 0 && cities?.map((city) => (
        <Accordion key={city} sx={{ background: 'none', width: '92vw' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ paddingBottom: 0, borderBottom: 0.2, borderColor: 'divider' }}
          >
            <Typography variant="h7">{city}</Typography>
          </AccordionSummary>
          <AccordionDetails key={city}>
            <List sx={{ margin: 0, padding: 0, overflow: 'auto' }}>
              {(holidays[city]).map((holiday, index) => (
                <>
                  <ListItem key={index} sx={{ margin: 0, padding: 0.5 }}>
                    <ListItemAvatar>
                      <Avatar src={holiday.image} />
                    </ListItemAvatar>
                    <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                      <ListItemText>{holiday.name}</ListItemText>
                      <Typography
                        sx={{ color: 'grey', fontSize: '12px' }}
                      >{`${holiday.date}, ${holiday.day} - India`}</Typography>
                    </Grid>
                  </ListItem>
                  <Divider />
                </>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </Grid>
  );
};

export default Holidays;
